import { useAppDispatch, useAppSelector } from "../../app/store/hooks";

import { setCalendarTable, updateTable, updateCurrenTableId } from "./slice";
import _ from "lodash";

export const useTable = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.table);

    return {
        currentTable: selector.currentTable,
        currenTableId: selector.currentTableId,
        isCalendarVisible: selector.isCalendarVisible,
        updateCurrentTable: payload => dispatch(updateTable(payload)),
        setCalendarTableVisible: payload => dispatch(setCalendarTable(payload)),
        updateCurrentTableId: () =>
            dispatch(updateCurrenTableId(_.uniqueId(selector.currentTable))),
    };
};
